import ListMatchTableRow from 'dashboard/components/ListMatches/ListMatchTableRow';
import TableLayout, { TableNullState, TableTH } from 'dashboard/layouts/TableLayout';
import { List } from 'dashboard/models/list';
import { ListItem } from 'dashboard/models/list-item';
import { ListMatch } from 'dashboard/models/list-match';
import Card from 'design-system/components/Card';

interface ListMatchesProps {
  lists: Record<string, List>;
  listItems: Record<string, ListItem>;
  listMatches: Record<string, ListMatch>;
}

const ListMatches = ({ lists, listItems, listMatches }: ListMatchesProps) => {
  return (
    <Card>
      <Card.Body>
        <TableLayout
          isEmpty={Object.keys(listMatches).length === 0}
          isLoading={false}
          showHeader={Object.keys(listMatches).length > 0}
          headerTR={
            <>
              <TableTH>List name</TableTH>
              <TableTH>List type</TableTH>
              <TableTH>Matched item</TableTH>
              <TableTH>Source</TableTH>
            </>
          }
          nullState={
            <TableNullState>
              <h3>There are no list matches.</h3>
            </TableNullState>
          }
        >
          {Object.values(listMatches).map((lm) => (
            <ListMatchTableRow
              list={lists[lm.relationships.list.data.id]}
              listItem={listItems[lm.relationships['list-item'].data.id]}
              listMatch={lm}
              key={lm.id}
            />
          ))}
        </TableLayout>
      </Card.Body>
    </Card>
  );
};

export default ListMatches;
